/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PaymentDetails } from "./PaymentDetails";
import { PaymentOverview } from "./PaymentOverview";
import { debounce, receivingCountryData } from "../../utils";
import { Modals } from "./Modals";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { panDeclaration, selectedPurpose, selectVendor, showTimerText, transactionDetails, vendorCodes } from "../../store";
import { bookRate, fxRates, getTransactionSummary } from "../../services/remittance";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/ui/Loader";
import { Mixpanel } from "../../constants/mixpanel";
import { callRatesApi } from "../../services/margin";
import { useIdleTimeout } from "../../hooks/useIdleTimeout";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Amount = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const navigate = useNavigate();
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [sendingAmount, setSendingAmount] = React.useState<number>(
    transactionData?.user_send ?? 10000,
  );
  const [receivingAmount, setReceivingAmount] = React.useState<any>();
  const purpose = useRecoilValue(selectedPurpose);
  const [rate, setRate] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [isPurposeModalOpen, setIsPurposeModalOpen] = useState(false);
  const [isPanModelOpen, setIsPanModelOpen] = useState(false);
  const [destCurrency, setDestCurrency] = useState<string>(localStorage.getItem("destCurr") ?? "USD");
  const [nostro, setNostro] = useState<string>("our");
  const [tcs, setTcs] = useState<any>();
  const [isTcsPresent, setIsTcsPresent] = useState<boolean>(false);
  const [pan, setPan] = useState<string>("");
  const panDeclarationValue = useRecoilValue(panDeclaration);
  const [declareAmount, setDeclareAmount] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isEducation, setIsEducation] = useState<boolean>(() => {
    const storedValue = localStorage.getItem("isEducation");
    return storedValue === "false" ? false : storedValue === "true" ? true : false;
  });
  const [isErrorPresent, setIsErrorPresent] = useState<boolean>(false);
  const [receiveLocked, setReceiveLocked] = useState<boolean>(false);
  const [isBene, setIsBene] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const baseCurrency = "INR";
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [moneySendViaMoneyhop, setMoneySentViaMoneyhop] = useState<number>(0);
  const [enableDecalreAmount, setEnableDeclareAmount] = useState<boolean>(false);
  const [modalLoading, setModalLoading] = useState<boolean>(false);
  const [firstTimeLoanPopup, setFirstTimeLoanPopup] = useState<boolean>(false);
  const [cardRates, setCardRates] = useState([]);
  const [onChangeHandlerType, setOnChangeHandleType] = React.useState<string>("send");
  const [summaryLoading, setSummaryLoading] = React.useState<boolean>(false);


  const idToken = localStorage.getItem("userToken") || "";
  const userKey = localStorage.getItem("userKey") || "";
  // const timer = Number(process.env.REACT_APP_SEND_MONEY_TIMER)|| 300000;
  const setShowTimerModal = useSetRecoilState(showTimerText);

  const prevValuesRef = useRef({
    sendingAmount: 0 as number,
    receivingAmount: 0 as number,
    purposeValue: "" as string | null,
    receiveCurrency: "" as string,
    sendingCurrency: "" as string,
    rate: 0 as number,
    vendorCode: "" as string,
    isPanModelOpen:false as boolean,
  isEducation: (() => {
    const storedValue = localStorage.getItem("isEducation");
    return storedValue === "false" ? false : storedValue === "true" ? true : false;
  })(),
    declareAmount: 0 as number,
    panDeclarationValue:"" as string,
    isBene :false as boolean,
    nostro:"our" as string
  });

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (purpose?.purposeValue) {
      getCardRatesApi();
    }
  }, [purpose?.purposeValue]);

  useEffect(() =>{
    if(receiveLocked){
      setOnChangeHandleType("receive");
      localStorage.setItem("onChangeHandler","receive")
    }
    else{
      setOnChangeHandleType("send");
      localStorage.setItem("onChangeHandler","send")
    }
  },[receiveLocked])

  const lockConversionRate = async()=>{
    setLoading(true);
    const body= {
      userKey: userKey,
      baseCurrency: baseCurrency,
      destCurrency: destCurrency
    }
      bookRate(body,idToken).then((response) => {
        setErrorMessage("");
        setLoading(false);
      }
      ).catch((err) => {
        setLoading(false);
        setErrorMessage(err?.response?.data?.error?.type);
      }
      ).finally(() => {
        setLoading(false);
      })
  }

  const proceedClick = () => {

    Mixpanel.track("Currency", {
      selected_you_send: sendingAmount,
      selected_currency_you_send: baseCurrency,
      selected_they_recieve: receivingAmount,
      selected_currency_they_receive: destCurrency,
    });
    Mixpanel.track("Purpose", {
      select_purpose: purpose?.purposeCode,
    });
    Mixpanel.track("Enter Rate", {
      Enter_Rate: rate,
    });
    Mixpanel.track("Enter Rate", {
      Enter_Rate: rate,
    });
    Mixpanel.track("Vendor Code", {
      Vendor_code: vendorCode?.vendorCode,
    });
    if (
      purpose?.purposeValue === "Overseas Education - University Fees" ||
      purpose?.purposeValue === "Overseas Education - Living Expenses"
    ) {
      Mixpanel.track("Education Selected", {
        Loan_letter: isEducation ? "Yes_Loan_letter" : "No_Loan_letter",
      });
    }
    Mixpanel.track("Proceed_sendmoney");
    navigate("/remitter");
    setShowTimerModal(true);
    lockConversionRate();
  };

  const handlePanBasedClick = () => {
    setIsPanModelOpen(true);
  };

  useEffect(() => {
    const code = purpose?.purposeCode;
    if (code === "S1301" || code === "S1302") {
      setNostro("bene");
    } else if (code === "S0305" && nostro !== "bene") {
      setNostro("our");
    } else {
      setNostro(nostro === "our" ? "bene" : "our");
    }
  }, [purpose?.purposeCode]);

  useMemo(() => {
    !isErrorPresent && setErrorMessage("");
  }, [isErrorPresent]);


  useEffect(() => {
    if (!isPanModelOpen) {
      setEnableDeclareAmount(false);
      // setMoneySentViaMoneyhop(0);
    }
    else if (isPanModelOpen) {
        setEnableDeclareAmount(true);
      }

  }, [isPanModelOpen]);


  useEffect(() => {
    // Only store `true` or `false` in localStorage, as stringified booleans
    if (isEducation !== null) {
      localStorage.setItem("isEducation", JSON.stringify(isEducation));
    }

    // Handle other storage items like `tcs`
    localStorage.setItem("tcs", tcs);
  }, [isEducation, tcs]);



  useEffect(() => {
    if (
      purpose?.purposeValue === "Overseas Education - University Fees" ||
      purpose?.purposeValue === "Overseas Education - Living Expenses"
    ) {
      // if (tcs !== 0) {
        setIsModalOpen("loan");
      // }
    } else {
      setIsModalOpen("");
    }
  }, [purpose?.purposeValue]);



  useEffect(() => {
    const shouldRun =
      (onChangeHandlerType === "send" && sendingAmount !== undefined) ||
      (onChangeHandlerType === "receive" && receivingAmount !== undefined);
    if (!shouldRun) return;
    localStorage.setItem("onChangeHandler", onChangeHandlerType);
    const delayDebounce = setTimeout(() => {
      const body =
        onChangeHandlerType === "send" && !receiveLocked
          ? { user_send: sendingAmount }
          : { reciepient_recieve: receivingAmount };

      const isSendChanged =
        onChangeHandlerType === "send" &&
        prevValuesRef.current.sendingAmount !== sendingAmount;

      const isReceiveChanged =
        onChangeHandlerType === "receive" &&
        prevValuesRef.current.receivingAmount !== receivingAmount;

      const isPurposeChanged =
        prevValuesRef.current.purposeValue !== purpose?.purposeValue;

      const isReceiveCurrencyChanged =
        prevValuesRef.current.receiveCurrency !== destCurrency;

      const isSendingCurrencyChanged =
        prevValuesRef.current.sendingCurrency !== baseCurrency;
      
      const isRateChanged = prevValuesRef.current.rate !== rate;

      const isVendorCodeChanged =
        prevValuesRef.current.vendorCode !== vendorCode?.userId;

      const isPanModalOpened = prevValuesRef.current.isPanModelOpen !== isPanModelOpen;
      const isEducationChanged = prevValuesRef.current.isEducation !== isEducation
      const isPanDeclarationAmountChanged = prevValuesRef.current.declareAmount !== declareAmount;
      const isPanDeclarationChanged = prevValuesRef.current.panDeclarationValue !== panDeclarationValue;
      const isBeneChanged = prevValuesRef.current.isBene !== isBene
      const isNostroChanged = prevValuesRef.current.nostro !== nostro

      const shouldCallApi =
        !hasFetchedRef.current ||
        isSendChanged ||
        isReceiveChanged ||
        isPurposeChanged ||
        isReceiveCurrencyChanged ||
        isSendingCurrencyChanged ||
        isRateChanged ||
        isVendorCodeChanged ||
        isPanModalOpened ||
        isEducationChanged ||
        isPanDeclarationAmountChanged ||
        isPanDeclarationChanged ||
        isBeneChanged ||
        isNostroChanged

      if (shouldCallApi) {
        hasFetchedRef.current = true;
        prevValuesRef.current = {
          sendingAmount,
          receivingAmount,
          purposeValue: purpose?.purposeValue,
          receiveCurrency: destCurrency,
          sendingCurrency: baseCurrency,
          rate: rate,
          vendorCode: vendorCode?.userId,
          isPanModelOpen:isPanModelOpen,
          isEducation:isEducation,
          declareAmount:declareAmount,
          panDeclarationValue:panDeclarationValue,
          isBene:isBene,
          nostro:nostro
        };

        setSummaryLoading(true);
        const nostroBody =
          nostro === "our"
            ? { isBene: false }
            : nostro === "bene"
              ? { isBene: true }
              : {};

        localStorage.setItem("declareAmount", String(declareAmount ?? 0))
        getTransactionSummary(
          {
            ...body,
            ...nostroBody,
            transVendorKey: vendorCode?.userId,
            base_currency: baseCurrency,
            dest_currency: destCurrency,
            hop_coins: 0,
            isEducation: isEducation,
            pan_number: panDeclarationValue,
            purposeCode: purpose?.purposeCode,
            vendor_key: currentUser.vendor_key,
            transaction_purpose: purpose?.purposeValue,
            conversion_rate: rate || "",
            declare_amount: declareAmount ?  declareAmount : null,
          },
          idToken
        )
          .then((response) => {
            setErrorMessage("");
            setIsErrorPresent(false);
            localStorage.setItem("conversionRate", response?.data?.conversion_rate);
            setTransactionData((prev) => ({
              ...prev,
              ...response?.data,
              transactionLeadIds: {
                ...prev.transactionLeadIds,
                ...(response?.data?.transactionLeadIds || {}),
              },
            }));
            if (onChangeHandlerType === "send") {
              setReceivingAmount(response?.data?.reciepient_recieve);
              setOnChangeHandleType("send");
              localStorage.setItem("onChangeHandler","send")
            } else {
              setSendingAmount(response?.data?.user_send);
              setOnChangeHandleType("receive");
              localStorage.setItem("onChangeHandler","receive")
            }          
            setMoneySentViaMoneyhop(response?.data?.money_sent_via_moneyhop_in_current_year);

            if (response?.data?.tcs > 0) {
              setIsTcsPresent(true);
              setTcs(response?.data?.tcs)
            } else {
              setIsTcsPresent(false);
            }
          })
          .catch((error) => {
            setErrorMessage(error?.response?.data?.error?.type);
            setIsErrorPresent(true);
          })
          .finally(() => {
            setSummaryLoading(false);
          });
      }
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [
    sendingAmount,
    receivingAmount,
    baseCurrency,
    destCurrency,
    purpose?.purposeCode,
    purpose?.purposeValue,
    onChangeHandlerType,
    vendorCode,
    rate,
    nostro,
    isEducation,
    isPanModelOpen,
    panDeclarationValue,
    declareAmount,
    isBene,
    receiveLocked
  ]);

  const getCardRatesApi = async () => {
    const req = await callRatesApi();
    const res = await req?.data;
    if (res) {
      setCardRates(res?.cardRate);
    }
  };

  const getFxRates = () => {
    fxRates(destCurrency).then((response) => {
      const marginValue =
        purpose?.purposeCode === "S1302"
          ? response.data.margin_value_gift
          : purpose?.purposeCode === "S1301"
            ? response.data.margin_value_maintanence
            : response.data.margin_value;

      const vendorMarginValue =
        purpose?.purposeCode === "S1302"
          ? response.data.vendor_margin_value_gift
          : purpose?.purposeCode === "S1301"
            ? response.data.vendor_margin_value_maintanence
            : response.data.vendor_margin_value;

      const totalRate: any =
        parseFloat(response.data.ibr) + parseFloat(marginValue) + parseFloat(vendorMarginValue);
      setRate(parseFloat(totalRate.toFixed(4)));
    });
  };

  useEffect(() => {
    localStorage.setItem("destCurr", destCurrency)
  }, [destCurrency])

  useEffect(() => {
    getFxRates();
  }, [purpose?.purposeCode, destCurrency]);


  // const handleTimeout = ()=>{
  //   toast.success("Rates refreshed.", { containerId: "top-right-toast" });    
  //   setShowToast(true);
  //   console.log("triggereed")
  //   toast.success("Rates refreshed.", { containerId: "top-right-toast", position: "top-right", autoClose: 5000, pauseOnFocusLoss: true });
  //   debouncedSendTransferSummary(sendingAmount, destCurrency);
  // }
  
  // const { isIdle, remainingTime } = useIdleTimeout({
  //   timeout: 300000,
  //   // timeout: 5_000,
  //   onTimeout: handleTimeout
  // });



  return (
    <div>
      <div className="flex mt-10 w-[1080px] ml-8 mr-16 space-x-24 scale-90">
        <PaymentOverview
          sendingAmount={sendingAmount}
          recievingAmount={receivingAmount}
          sendingCurrency={"INR"}
          recieivingCurrency={destCurrency}
          setSendingAmount={setSendingAmount}
          setReceivingAmount={setReceivingAmount}
          purposeCode={purpose?.purposeCode}
          rate={rate}
          setRate={setRate}
          proceedClick={proceedClick}
          destCurrency={destCurrency}
          setIsModalOpen={setIsModalOpen}
          setIsPurposeModalOpen={setIsPurposeModalOpen}
          base_currency={baseCurrency}
          errorMessage={errorMessage}
          setErrorMessage={(error: any) => setErrorMessage(error)}
          purposeValue={purpose?.purposeValue}
          // sendTransferSummary={sendTranferSummary}
          // rateTransferSummary={rateTransferSummary}
          // receiveTransferSummary={receiveTransferSummary}
          isErrorPresent={isErrorPresent}
          receiveLocked={receiveLocked}
          setReceiveLocked={setReceiveLocked}
          cardRates={cardRates}
          setFirstTimeLoanPopup={setFirstTimeLoanPopup}
          firstTimeLoanPopup={firstTimeLoanPopup}
          loading={loading}
          tcs={tcs}
          setOnChangeHandleType={setOnChangeHandleType}
        />
        <div className="w-1 h-[850px] border-4 border-r"></div>
        <PaymentDetails
          recievingAmount={receivingAmount}
          nostro={nostro}
          setNostro={setNostro}
          handlePanBasedClick={handlePanBasedClick}
          // handleGeneralClick={handleGeneralClick}
          setIsModalOpen={setIsModalOpen}
          setIsPanModelOpen={setIsPanModelOpen}
          setPan={setPan}
          pan={pan}
          purposeCode={purpose?.purposeCode}
          setIsErrorPresent={setIsErrorPresent}
          loading={loading}
        />
        <Modals
          isModalOpen={isModalOpen}
          isPurposeModalOpen={isPurposeModalOpen}
          setIsModalOpen={setIsModalOpen}
          isPanModelOpen={isPanModelOpen}
          setIsPanModelOpen={setIsPanModelOpen}
          setIsPurposeModalOpen={setIsPurposeModalOpen}
          receivingCountryModalData={receivingCountryData}
          destCurrency={destCurrency}
          setDestCurrency={setDestCurrency}
          purposeCode={purpose?.purposeCode}
          setFirstTimeLoanPopup={setFirstTimeLoanPopup}
          setPan={setPan}
          firstTimeLoanPopup={firstTimeLoanPopup}
          setIsEducation={setIsEducation}
          // sendTransferSummary={sendTranferSummary}
          sendingAmount={sendingAmount}
          errorMessage={errorMessage}
          tcs={tcs}
          setDeclareAmount={setDeclareAmount}
          moneySendViaMoneyhop={moneySendViaMoneyhop}
          enableDecalreAmount={enableDecalreAmount}
          modalLoading={modalLoading}
          setEnableDeclareAmount={setEnableDeclareAmount}
          declareAmount={declareAmount}
          setTcs={setTcs}
        />
      </div>
    </div>
  );
};

export default Amount;
